import React from "react";
import { HStack, VStack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

export const VisitOfferDetail = (props: { name: string }) => {
  return (
    <VStack w="full" spacing="5px" alignItems="start" pt="28px" mb="16px">
      <Text fontWeight="bold" fontSize="1rem" color="gray.800" m="0">
        <FormattedMessage
          {...messages["serviceRequest.visitOfferDetail.serviceProvider"]}
          values={{ serviceProviderName: props.name }}
        />
      </Text>

      <HStack justifyContent="space-between" w="full">
        <Text fontSize="1rem" m="0">
          <FormattedMessage
            {...messages["serviceRequest.visitOfferDetail.title"]}
          />
        </Text>
        <Text
          fontSize={{ base: "1rem", md: "0.875rem" }}
          fontWeight="bold"
          color="gray.800"
        >
          <FormattedMessage
            {...messages["serviceRequest.visitOfferDetail.status"]}
          />
        </Text>
      </HStack>
      <Text fontSize="0.75rem">
        <FormattedMessage
          {...messages["serviceRequest.visitOfferDetail.description"]}
        />
      </Text>
    </VStack>
  );
};
